import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
export const CenteredContentContainer = ({ children, }) => {
    return (_jsx(CenteredContentContainerRoot, { children: children }));
};
const CenteredContentContainerRoot = styled.div `
    width: 100%;
    max-width: 68rem;
    padding: 0 1rem;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
`;
